import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subscription, lastValueFrom } from 'rxjs';
import { RmsModule } from '@rms';
import { Column } from '@interfaces';
import { EwsDataService, EwsFilters } from '../../../../../services/ews-data.service';
import { EwsRefresh } from '../../../../../services/ews-refresh';
import { downloadCsv } from '../../../../../services/swap-data.service';
@Component({selector:'app-ews-reports',imports:[RmsModule],templateUrl:'./ews-reports.component.html',styleUrl:'./ews-reports.component.scss'})
export class EwsReportsComponent implements OnInit, OnDestroy {
  Reports = [
    {value:'origin',label:'Origin Alert Summary',icon:'public',description:'Coffee needs by origin, with current spot and forward availability.'},
    {value:'yearly',label:'Yearly Burn Rate Summary',icon:'query_stats',description:'Five calendar years of pickups and monthly burn by coffee group.'},
    {value:'potholes',label:'EWS Potholes',icon:'warning',description:'Months where projected stock falls below zero, including gaps before arrivals.'},
    {value:'traders',label:'Trader Customer EWS Summary',icon:'people',description:'Customer burn and reserve coverage, organised by trader and coffee group.'},
    {value:'setup',label:'Group & Crop Setup',icon:'fact_check',description:'Active coffee SKUs with missing groups, crop cycles or export windows.'}
  ];
  Kind = 'origin'; Filters: EwsFilters = {BurnRange:3}; Rows:any[]=[]; Columns:Column[]=[];
  WarehouseOptions:any[]=[{value:'',label:'All warehouses'}]; Warehouse:any='';
  BurnOptions=[{value:3,label:'3 months'},{value:6,label:'6 months'},{value:12,label:'12 months'}];
  Loading=false; Error=''; UpdatedAt:Date|null=null; RunInfo:any=null; TableKeys:string[]=[];
  private refresh=new EwsRefresh(); private live?:Subscription;
  constructor(private ews:EwsDataService,private cdr:ChangeDetectorRef){}
  async ngOnInit(){
    this.ews.getOptions().subscribe({next:o=>{this.WarehouseOptions=[{value:'',label:'All warehouses'},...o.Warehouses.map(w=>({value:w.WarehouseID,label:w.LocationShortName||w.LocationName}))];this.cdr.markForCheck();}});
    this.live=this.ews.changes$.subscribe(()=>this.queue()); await this.load();
  }
  ngOnDestroy(){this.refresh.destroy();this.live?.unsubscribe();}
  get Selected(){return this.Reports.find(r=>r.value===this.Kind)!;}
  choose(kind:string){this.Kind=kind;this.Rows=[];this.TableKeys=[];this.Columns=[];this.queue();}
  queue(){this.Loading=true;this.refresh.schedule(()=>this.load());}
  async load(){
    const rev=this.refresh.begin();this.Loading=true;this.Error='';
    try{
      const d=await lastValueFrom(this.ews.getReports(this.Kind,{...this.Filters,WarehouseID:this.Warehouse===''?null:Number(this.Warehouse)}));
      if(!this.refresh.current(rev))return;
      this.Rows=d.Rows||[];this.RunInfo=d.RunInfo;
      if(!this.Columns.length && this.Rows.length){
        this.Columns=Object.keys(this.Rows[0]).map(key=>({key,label:key.replace(/([a-z])([A-Z])/g,'$1 $2'),hidden:key.endsWith('ID'),
          type:/Month$|Date$|Pickup$|Thru$/.test(key)?'date':typeof this.Rows[0][key]==='number'?'number':undefined,
          cellClass:(r:any)=>r.Shortfall>0||r.Status==='Short of 3 months'?'report-alert':''} as Column));
        this.TableKeys=[this.Kind];
      }
      this.UpdatedAt=new Date();
    }catch(e:any){if(this.refresh.current(rev))this.Error=e?.error?.error||'Could not load this report.';}
    finally{if(this.refresh.current(rev)){this.Loading=false;this.cdr.markForCheck();}}
  }
  export(){downloadCsv(this.Rows,`ews-${this.Kind}-${new Date().toISOString().substring(0,10)}.csv`);}
}
